/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Table_UserInputs */

const en_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const fr_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateur`)
};

const de_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

const it_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utente`)
};

const ru_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь`)
};

const es_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

const zh_cn2_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

const ja_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー`)
};

const hi_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता`)
};

const pt_pt2_team_manager_table_user = /** @type {(inputs: Team_Manager_Table_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Team_Manager_Table_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_table_user = /** @type {((inputs?: Team_Manager_Table_UserInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Table_UserInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_table_user(inputs)
	if (locale === "de") return de_team_manager_table_user(inputs)
	if (locale === "it") return it_team_manager_table_user(inputs)
	if (locale === "ru") return ru_team_manager_table_user(inputs)
	if (locale === "es") return es_team_manager_table_user(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_table_user(inputs)
	if (locale === "ja") return ja_team_manager_table_user(inputs)
	if (locale === "hi") return hi_team_manager_table_user(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_table_user(inputs)
	return en_team_manager_table_user(inputs)
});